import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import styles from "./products.module.scss";
import Image from "next/image";
import Head from "next/head";
import HeroGradientTextWithIcon from "@/components/heroGradientTextWithIcon/heroGradientTextWithIcon";
import ProductsTabsSectionV2 from "@/components/productsTabsSectionV2/productsTabsSectionV2";
import FeaturesSwiper from "@/components/featuresSwiper/featuresSwiper";
import StaticVsDynamicV2 from "@/components/staticVsDynamicV2/staticVsDynamicV2";
import FaqWithCta from "@/components/faqWithCta/faqWithCta";

const Products = () => {
  const router = useRouter();
  const [allImages, setAllImages] = useState(null);
  const [currentUrl, setCurrentUrl] = useState("");
  const [domainUrl, setDomainUrl] = useState("");
  useEffect(() => {
    if (window.location.href) {
      setCurrentUrl(window.location.href);
      setDomainUrl(window.location.hostname);
    }
  }, []);
  useEffect(() => {
    (async () => {
      const svgData = await fetch("/images.json").then((res) => res.json());
      if (svgData != null) {
        setAllImages(svgData);
      }
    })();
  }, []);

  const baseUrl = `https://${domainUrl || "qrhub.io"}`;
  const defaultOgImage = `${baseUrl}/images/featured_images/qrhub-featured.jpg`;
  const defaultOgUrl = currentUrl || `${baseUrl}${router.asPath || ""}`;

  return (
    <>
      <Head>
        <title>QRHUB Products</title>
        <meta
          name="description"
          content="Empower your business with tailored QR code Products"
        ></meta>
        <meta property="og:title" content="QRHUB Products"></meta>
        <meta
          property="og:description"
          content="Empower your business with tailored QR code Products"
        ></meta>
        <meta property="og:image" content={defaultOgImage}></meta>
        <meta property="og:url" content={defaultOgUrl}></meta>
      </Head>
      <div className={`${styles["products"]}`}>
        <HeroGradientTextWithIcon
          subtitle="QR Code"
          title="Products"
          description="Empower your business with tailored <br/> QR code Products"
          image={
            <Image
              src={`/images/products/products.svg`}
              alt="QRHUB Products"
              width={311}
              height={311}
            />
          }
          buttonTitle="Start for free"
          buttonUrl={process.env.NEXT_PUBLIC_DASHBOARD_URL}
          target={"_blank"}
          isProduct={false}
          isSolution={false}
          isStatic={false}
        />

        <ProductsTabsSectionV2 />

        <FeaturesSwiper />
        <div className={`custom-container`}>
          <div className={`inner`}>
            <StaticVsDynamicV2 />
          </div>
        </div>
        <FaqWithCta
          title="Ready to Get Started?"
          description="QRHUB can transform your business and connect you with your audience
        like never before."
          buttonTitle={`Sign Up Now`}
          buttonUrl={process.env.NEXT_PUBLIC_DASHBOARD_URL}
          target={"_blank"}
        />
      </div>
    </>
  );
};

export default Products;
